import { useEffect } from "react";

export default function AuthPopupCallback() {
  useEffect(() => {
    const m = (window.location.hash || "").match(/session_id=([^&]+)/);
    if (m && window.opener) {
      try {
        window.opener.postMessage(
          { type: "ns-google-session", session_id: m[1] },
          window.location.origin
        );
      } catch {}
      setTimeout(() => { try { window.close(); } catch {} }, 250);
    }
  }, []);
  return (
    <div className="min-h-screen bg-[#0A0605] flex flex-col items-center justify-center gap-3 text-white">
      <div className="w-10 h-10 rounded-full border-2 border-[#DC2626]/30 border-t-[#DC2626] animate-spin"/>
      <p className="text-sm text-zinc-400">Signing you in…</p>
    </div>
  );
}
